"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getContactToShow = void 0;
require("core-js/modules/es6.array.find.js");
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
function cov_2qrcfv2ovp() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/TsHeaderHelper.js";
  var hash = "d419889929bfb32daa1d6a974e5b79d21b4fe8b6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/TsHeaderHelper.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 29
        },
        end: {
          line: 1,
          column: 35
        }
      },
      "1": {
        start: {
          line: 3,
          column: 25
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "2": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      "3": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 32
        }
      },
      "4": {
        start: {
          line: 7,
          column: 22
        },
        end: {
          line: 7,
          column: 81
        }
      },
      "5": {
        start: {
          line: 7,
          column: 48
        },
        end: {
          line: 7,
          column: 80
        }
      },
      "6": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 64
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 25
          },
          end: {
            line: 3,
            column: 26
          }
        },
        loc: {
          start: {
            line: 3,
            column: 53
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 7,
            column: 41
          }
        },
        loc: {
          start: {
            line: 7,
            column: 48
          },
          end: {
            line: 7,
            column: 80
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 4,
            column: 5
          },
          end: {
            line: 4,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 5
          },
          end: {
            line: 4,
            column: 33
          }
        }, {
          start: {
            line: 4,
            column: 37
          },
          end: {
            line: 4,
            column: 46
          }
        }],
        line: 4
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 48
          },
          end: {
            line: 7,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 48
          },
          end: {
            line: 7,
            column: 52
          }
        }, {
          start: {
            line: 7,
            column: 56
          },
          end: {
            line: 7,
            column: 80
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 23
          },
          end: {
            line: 8,
            column: 40
          }
        }, {
          start: {
            line: 8,
            column: 43
          },
          end: {
            line: 8,
            column: 63
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d419889929bfb32daa1d6a974e5b79d21b4fe8b6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2qrcfv2ovp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2qrcfv2ovp();
var DEFAULT_CONTACT_ITEM = (cov_2qrcfv2ovp().s[0]++, 'name');
cov_2qrcfv2ovp().s[1]++;
var getContactToShow = exports.getContactToShow = function getContactToShow(contactItems, language) {
  cov_2qrcfv2ovp().f[0]++;
  cov_2qrcfv2ovp().s[2]++;
  if ((cov_2qrcfv2ovp().b[1][0]++, !(0, _isArray.default)(contactItems)) || (cov_2qrcfv2ovp().b[1][1]++, !language)) {
    cov_2qrcfv2ovp().b[0][0]++;
    cov_2qrcfv2ovp().s[3]++;
    return DEFAULT_CONTACT_ITEM;
  } else {
    cov_2qrcfv2ovp().b[0][1]++;
  }
  var contactItem = (cov_2qrcfv2ovp().s[4]++, contactItems.find(function (item) {
    cov_2qrcfv2ovp().f[1]++;
    cov_2qrcfv2ovp().s[5]++;
    return (cov_2qrcfv2ovp().b[2][0]++, item) && (cov_2qrcfv2ovp().b[2][1]++, item.locale === language);
  }));
  cov_2qrcfv2ovp().s[6]++;
  return contactItem ? (cov_2qrcfv2ovp().b[3][0]++, contactItem.value) : (cov_2qrcfv2ovp().b[3][1]++, DEFAULT_CONTACT_ITEM);
};